export const auth = {
    authModalTitle: 'Vyžadovaná autorizácia',
    authModalDescription:
        'Na vykonanie tejto akcie je nutná autorizácia. Vyberte jednu z nasledovných možností:',
    loginHeading: 'Prihlásenie',
    createAccount: 'Vytvoriť nový účet',
    registrationHeading: 'Registrácia',
    pleaseFillAll: 'alebo prosím vyplňte všetky polia nižšie',
    inputWithNameIsRequired: ['Pole', 'je povinné'],
    orUse: 'alebo použite',
    register: 'Registrovať',
    login: 'Prihlásiť sa',
    nameLabel: 'Meno',
    emailLabel: 'Email',
    passwordLabel: 'Heslo',
    newPasswordLabel: 'Nové heslo',
    firstName: 'Meno',
    lastName: 'Priezvisko',
    editProfile: 'Upraviť profil',
    changePassword: 'Zmeniť heslo',
    confirmPasswordLabel: 'Potvrdenie hesla',
    iHaveRead: [
        'Prečítal som si a súhlasím s',
        'Podmienkami',
        'a',
        'Ochranou súkromia',
        'pre dokončenie tohto',
        'procesu.'
    ],

    passPolicyLength: 'Heslo je krátke: minimálna dĺžka musí byť 8 znakov.',
    invalidMailOrPassword: 'Neplatné meno alebo heslo.',
    passPolicyUpperCase: 'Heslo musí obsahovať aspoň jedno veľké písmeno.',
    passPolicyNumber: 'Heslo musí obsahovať obsahovať aspoň jednu číslicu.',
    passAndConfirmDontMatch: "Heslo a potvrdenie hesla sa nezhoduje.",

    dontHaveAnAccount: 'Nemáte ešte účet?',
    alreadyHaveAnAccount: 'Máte užívateľský účet?'
};
